import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/jobs.json";

export const useJobs = ({ locale, filters = null, limit = 8 } = {}) => {
  let collection = useSourceFlowCollection(data.jobs).filter(function(job) {
    return (
      job.categories.find((cat) =>
          cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b" &&
          cat.values.find((x) => x.name === (locale == "/us/" ? "United States" : "United Kingdom"))
      )
  )});

  if (filters && filters.length > 0) {
    collection = collection.filter((job) => job?.categories.find((cat) => cat.id === (locale == "/us/" ? "0c6466fd-1282-46c3-8674-1a4efcb02472" : "cf3eb687-952a-43b2-8ff6-b37dadf30398"))?.values.some((filter) => filters?.includes(filter.id)));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useJobs;
